import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Modal } from '../../../widgets';

const PanelControlEstudiosView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const panelControlEstudiosStore = Redux.useSelector(
    (state) => state.panelControlEstudios,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container>
      {/* <Grid container sx={{ mb: 2 }}> */}
      {/* <AlertWidget alert={panelControlEstudiosStore.alertView} />

        <BotonComponent
          click={async () => {
            await setActivoPanelControlEstudiosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          blue
          mr={2}
        />
        {panelControlEstudiosStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoPanelControlEstudiosAction(dispatch, null);
              await allPanelControlEstudiosAction(
                dispatch,
                entidadesStore.activo.id,
                null
              );
            }}
            disabled={panelControlEstudiosStore.loadingAll}
            white
            text={
              panelControlEstudiosStore.loadingAll ? "Actualizando..." : "Actualizar"
            }
          />
        ) : null}
      </Grid>
      <ListadoPanelControlEstudios setOpenModalForm={(val) => setOpenModalForm(val)} />

      <Modal
        id="modalFormPanelControlEstudios"
        title={`${panelControlEstudiosStore.activo ? "Editar" : "Nuevo"} documento`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {panelControlEstudiosStore.activo ? (
          <Typography variant="h6">
            {panelControlEstudiosStore.activo.nombres} {panelControlEstudiosStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormPanelControlEstudios
          activo={panelControlEstudiosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal> */}
    </Grid>
  );
};

export default PanelControlEstudiosView;
